// Batch 33 · B33-1 (owner decision) — "Final analytical review" is its own sidebar item under "Completion forms" (above Review
// Points) and opens the review directly: 316(a) on an audit engagement, R316(a) on a review engagement (B33-2). The review
// screen carries the form's sign-off bar and evaluation questions (B33-4: the one place to work and sign).
import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { useEngagement } from "@/contexts/EngagementContext";
import FinalAnalyticalReview from "@/components/far/FinalAnalyticalReview";

export default function FinalAnalyticalReviewPage() {
  const { t } = useI18n();
  const { currentEngId } = useEngagement();
  return (
    <div className="space-y-4" data-testid="far-page">
      {currentEngId
        ? <FinalAnalyticalReview key={currentEngId} engId={currentEngId} />   /* PR 51 · P51-B1: a fresh screen per engagement */
        : <div className="rounded border p-6 text-sm text-muted-foreground" data-testid="far-page-no-engagement">{t("far.selectEngagement")}</div>}
    </div>
  );
}
